import { useState } from "react";
import { Pin, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { PageHeader, Field, SimpleSelect, Empty } from "@/components/common";
import { useApi, act } from "@/lib/useApi";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { dtTime } from "@/lib/fmt";

export default function Announcements() {
  const { user } = useAuth();
  const [items, reload] = useApi("/announcements");
  const [f, setF] = useState({ title: "", body: "", audience: "todos", pinned: false });
  const save = async () => { const r = await act(() => api.post("/announcements", f), "Comunicado publicado"); if (r) { setF({ title: "", body: "", audience: "todos", pinned: false }); reload(); } };
  return (
    <div>
      <PageHeader eyebrow="Mural" title="Comunicados" />
      <div className="grid lg:grid-cols-[1fr_360px] gap-6">
        <div className="space-y-3" data-testid="announcements-list">
          {!items?.length ? <Empty /> : items.map((a) => (
            <div key={a.id} className="panel p-5 fade-up">
              <div className="flex justify-between gap-3">
                <div><div className="eyebrow flex items-center gap-1">{a.pinned && <Pin className="w-3 h-3" />}{a.audience}</div><div className="font-display text-xl font-bold uppercase">{a.title}</div></div>
                {user.role === "admin" && <button onClick={async () => { await act(() => api.delete(`/announcements/${a.id}`), "Removido"); reload(); }} className="text-slate-400 hover:text-red-600" data-testid={`delete-ann-${a.id}`}><Trash2 className="w-4 h-4" /></button>}
              </div>
              <p className="text-sm text-slate-600 mt-2 whitespace-pre-wrap">{a.body}</p>
              <div className="text-xs text-slate-400 mt-2">{a.author} · {dtTime(a.created_at)}</div>
            </div>))}
        </div>
        <div className="panel p-5 space-y-3 h-fit">
          <div className="font-display text-lg font-bold uppercase">Novo comunicado</div>
          <Field label="Título"><Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="ann-title-input" /></Field>
          <Field label="Mensagem"><Textarea rows={5} value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="ann-body-input" /></Field>
          <Field label="Público"><SimpleSelect value={f.audience} onChange={(v) => setF({ ...f, audience: v })} testid="ann-audience-select"
            options={[["todos", "Todos"], ["alunos", "Alunos"], ["responsaveis", "Responsáveis"], ["professores", "Professores"]].map(([value, label]) => ({ value, label }))} /></Field>
          <label className="flex items-center gap-2 text-sm"><Switch checked={f.pinned} onCheckedChange={(v) => setF({ ...f, pinned: v })} />Fixar no topo</label>
          <Button onClick={save} className="w-full bg-red-600 hover:bg-red-700" data-testid="ann-save-btn">Publicar</Button>
        </div>
      </div>
    </div>
  );
}
